import { render, staticRenderFns } from "./CenterEdit.vue?vue&type=template&id=137e3c3d&"
import script from "./CenterEdit.vue?vue&type=script&lang=ts&"
export * from "./CenterEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports